
<Container :padding="0" :direction="direction" :gap="12" overflow="visible">
	<Container
		v-for="(option, idx) in options"
		:key="idx"
		:padding="0"
		direction="row"
		:gap="8"
		overflow="visible"
	>
		<component
			:is="componentToRender"
			:state="state"
			:disabled="disabled"
			:checked="isChecked(option)"
			:data-qa-field="`${dataQaId}-${getOptionDataQa(option)}`"
			@input="handleInput($event, option)"
		/>
		<Typography
			type="p2"
			color="dark"
			:data-qa="`${dataQaId}-${getOptionDataQa(option)}`"
			@click.native="handleInput($event, option)"
		>
			{{ getOptionLabel(option) }}
		</Typography>
		<slot :option="option" name="option_info"></slot>
	</Container>
</Container>
